import React, {createElement, useState} from 'react'
import moduleCss from './index.module.scss'

export interface Nav_3_props {
    nodeId: string
    style: object

    navList: Array<{
        title: string
        jumpTo: string
    }>
    height: number
    isAverageWidth: boolean

    normalStyle?: object

    hoverStyle?: object

    isHasDivider: boolean
    dividerStyle?: object

}

const Nav_3: React.FC<Nav_3_props> = (props) => {
    const { nodeId, navList, style, height, isAverageWidth, normalStyle, hoverStyle, isHasDivider, dividerStyle } = props

    const [ hoverIndex, setHoverIndex ] = useState(-1)

    const jump = (e) => {
        const { url } = e.currentTarget.dataset
        if (url) {
            document.getElementById(url).scrollIntoView({ behavior: 'smooth' })
        }
    }

    return (
        <div id={nodeId} className={moduleCss.nav_3} style={{ height: `${height}px`, ...style }}>
            {
                navList && navList.map((nav, index) => {
                    return (
                        <div className={moduleCss.navItemWp} style={{...(isAverageWidth ? { flex: 1 } : {} )}}>
                            <div
                                className={moduleCss.navItem}
                                key={index}
                                data-url={nav?.jumpTo}
                                onClick={jump}
                                onMouseEnter={() => setHoverIndex(index)}
                                onMouseLeave={() => setHoverIndex(-1)}
                                style={{ ...normalStyle, ...(hoverIndex === index ? hoverStyle : {}) }}
                            >
                                {nav?.title}
                            </div>
                            {
                                isHasDivider && index < navList.length - 1 &&
                                <div className={moduleCss.divider} style={dividerStyle} />
                            }
                        </div>

                    )
                })
            }
        </div>
    )
}

export default Nav_3
